import Http from '@/api/http.js'

export default {

  getLastPaymentMethods(client_id){
    return Http.get(`clients/${client_id}/last_payment_methods`);
  },

}